<template>
  <SectionSplit
    class="FinancialStatusDelay"
    :formats="[]"
    src="../../assets/landing-finances/twilight-solar.jpg">
    <h3>
      {{ $t("title") }}
    </h3>
    <p
      v-for="(paragraph, index) in $t('paragraphs')"
      :key="index"
      v-html="paragraph" />
  </SectionSplit>
</template>

<script>
import SectionSplit from 'views/components/SectionSplit'

export default {
  components: { SectionSplit },
}
</script>

<style lang="scss">
.FinancialStatusDelay {
  .Splitter-body {
    max-width: 50rem;
  }

  .body {
    padding: 2rem 0;
  }
}
</style>

<i18n>
{
  "en": {
    "title": "Because of the delay in publishing the semi-annual financial statements",
    "paragraphs": [
      "Under section (e)(ii) “Financial reporting” of Clause 10 “Special Undertakings” of the General Terms and Conditions of the bonds, ISIN code LT0000409963 (the <b>Bonds</b>), (the <b>Terms and Conditions</b>) of Sun Investment Group, UAB (legal entity code 302662621, registered office address Gedimino ave. 44A-501, Vilnius, Republic of Lithuania) (the <b>Issuer</b>) it is defined that Issuer shall prepare semi-annual interim unaudited consolidated and semi-annual interim unaudited stand-alone financial reports of the Issuer (hereinafter – <b>Financial Reports</b>) and publish them on the Issuer’s website www.suninvestmentgroup.com not later than in 3 (three) months after the expiry of relevant interim period.",
      "Issuer hereby informs that the Issuer will be late in publishing Financial Reports on its website, as required by the Terms and Conditions of the Bonds.",
      "The delay is due to unforeseen circumstances and temporary resource constraints.",
      "The Issuer fully understands the importance of timely reporting and assures bondholders and the trustee that it is actively working to finalize and publish the Financial Reports as soon as possible, and in any case no later than 23 October 2026.",
      "The Issuer apologizes for any inconvenience this delay may cause and thanks bondholders and trustee for their understanding."
    ]
  },
  "lt": {
    "title": "Dėl pusmečio finansinių ataskaitų pavėluoto paskelbimo",
    "paragraphs": [
      "Pagal Bendrųjų obligacijų sąlygų 10 straipsnio „Specialūs įsipareigojimai“ dalies (e)(ii) „Finansinė atskaitomybė“ nuostatas, taikomas obligacijoms, kurių ISIN kodas LT0000409963 (toliau – <b>Obligacijos</b>), (toliau – <b>Sąlygos</b>) Sun Investment Group, UAB (juridinio asmens kodas 302662621, buveinės adresas Gedimino pr. 44A-501, Vilnius, Lietuvos Respublika) (toliau – <b>Leidėjas</b>) įsipareigojo parengti pusmečio tarpines neaudituotas konsoliduotas ir pusmečio tarpines neaudituotas atskiras finansines ataskaitas (toliau – <b>Finansinės ataskaitos</b>) ir paskelbti jas Leidėjo interneto svetainėje www.suninvestmentgroup.com ne vėliau kaip per 3 (tris) mėnesius po atitinkamo laikotarpio pabaigos.",
      "Leidėjas informuoja, kad Finansinės ataskaitos nebus paskelbtos Leidėjo interneto svetainėje nustatytu laiku, kaip tai numatyta Obligacijų Sąlygose.",
      "Vėlavimas atsirado dėl nenumatytų aplinkybių ir laikino žmogiškųjų išteklių trūkumo.",
      "Leidėjas puikiai supranta savalaikės atskaitomybės svarbą ir užtikrina obligacijų turėtojus bei obligacijų turėtojų patikėtinį, kad deda visas pastangas kuo greičiau užbaigti ir paskelbti Finansines ataskaitas, bet ne vėliau kaip iki 2026 m. spalio 23 d.",
      "Leidėjas atsiprašo už galimus nepatogumus, kuriuos gali sukelti šis vėlavimas, ir dėkoja obligacijų turėtojams bei patikėtiniui už supratingumą."
    ]
  }
}
</i18n>
